import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss']
})
export class InviteComponent implements OnInit, AfterViewInit {
  redeSocial?: string;
  storeId?: number;

  constructor(
    private route: ActivatedRoute,
    private layoutService: LayoutService
  ) { }
  logoSrc?: string = 'assets/Logo_claro_sem.svg';
  ngOnInit(): void {
    this.storeId = Number(this.route.snapshot.paramMap.get('storeId'));

    // Se quiser escutar alterações dinâmicas (ex: navega entre invites sem destruir componente)
    // this.route.paramMap.subscribe(params => {
    //   this.redeSocial = params.get('rede_social') || '';
    //   this.storeId = Number(params.get('storeId'));
    // });
  }

  isDark: boolean = false;
  get dark(): boolean {
    return this.layoutService.config.colorScheme !== 'light';
  }

  ngAfterViewInit(): void {
    const layoutContainer = document.querySelector('.layout-container');

    if (layoutContainer) {
      this.isDark =
        this.layoutService.config.colorScheme === 'dark' ||
        this.layoutService.config.colorScheme === 'dim';

      this.logoSrc = this.isDark
        ? 'assets/Logo_escuro_sem.png'
        : 'assets/Logo_claro_sem.svg';
    }
  }


  connect(provider: 'youtube' | 'instagram' | 'tiktok') {
    if (provider === 'youtube') {
      const clientId = '814215832533-b4qkagjc0h2voi3cf80prscqj16bfn5n.apps.googleusercontent.com';
      const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/social-callback/youtube');
      const scope = encodeURIComponent('openid email profile');
      const state = btoa(JSON.stringify({ provider: 'google', nonce: Math.random().toString(36).substring(2) }));

      const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}`
        + `&redirect_uri=${redirectUri}`
        + `&response_type=code`
        + `&scope=${scope}`
        + `&prompt=select_account`
        + `&state=${encodeURIComponent(state)}`;

      window.open(url, 'Google Login', 'width=600,height=700,noopener,noreferrer');
    } else if (provider === 'instagram') {
      const clientId = '4107655592889616';
      const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/social-callback/instagram');
      const scopes = [
        'instagram_basic',
        'pages_show_list',
        'instagram_manage_comments',
        'pages_read_engagement',
        'pages_read_user_content',
        'business_management',
        'instagram_manage_insights',
      ].join(',');

      const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
      let stateObj: any = { selectedStoreId };

      stateObj.nonce = Math.random().toString(36).substring(2);
      const state = btoa(JSON.stringify(stateObj));

      const oauthUrl =
        'https://www.facebook.com/v22.0/dialog/oauth?' +
        `client_id=${clientId}` +
        `&redirect_uri=${redirectUri}` +
        `&scope=${encodeURIComponent(scopes)}` +
        `&response_type=code` +
        `&state=${encodeURIComponent(state)}`;

      window.open(oauthUrl, 'Instagram Login', 'width=600,height=700,noopener,noreferrer');
    } else if (provider === 'tiktok') {
      const clientKey = 'sbawrbor1sxz11n05g'; // sua client_key
      const redirectUri = encodeURIComponent('https://app.slicksell.com.br/auth/social-callback/tiktok');
      const scopes = encodeURIComponent('user.info.basic,user.info.profile,video.list');

      const selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
      let stateObj: any = { selectedStoreId };

      stateObj.nonce = Math.random().toString(36).substring(2);
      const state = btoa(JSON.stringify(stateObj));

      const url =
        `https://www.tiktok.com/v2/auth/authorize/?client_key=${clientKey}` +
        `&redirect_uri=${redirectUri}&response_type=code&scope=${scopes}&state=${state}`;

      window.open(url, 'TikTok Login', 'width=600,height=700,noopener,noreferrer');
    }
  }


  manage(provider: 'instagram' | 'tiktok' | 'youtube') {
    // TODO: navegar para tela de contas vinculadas
  }

}
